import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { requireAppCheck } from '@jfw/angular/shared/app-check';
import { EventListItemWrapper, RejectAcceptEventRequest } from '@jfw/types';
import { BehaviorSubject, firstValueFrom, Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class WholesalePotentialEventService {
  private readonly httpClient = inject(HttpClient);

  private platform_event_api_server_url: string | undefined;

  private readonly eventListWrapperSubject =
    new BehaviorSubject<EventListItemWrapper>({
      eventList: [],
      status: 'PENDING',
    });

  private readonly fetchDataTrigger = new Subject<any>();
  public readonly fetchDataTrigger$ = this.fetchDataTrigger.asObservable();

  public triggerFetchData(data?: any): void {
    this.fetchDataTrigger.next(data);
  }

  // Observable for components to subscribe to
  public readonly eventListWrapper$: Observable<EventListItemWrapper> =
    this.eventListWrapperSubject.asObservable();

  // Method to update the value
  public setEventListWrapper(wrapper: EventListItemWrapper): void {
    this.eventListWrapperSubject.next(wrapper);
  }

  public setPlatformEventApiUrl(url: string): void {
    this.platform_event_api_server_url = url;
  }

  public async apiRejectEvent(
    requestData: RejectAcceptEventRequest,
  ): Promise<string> {
    console.log('apiRejectEvent');

    if (this.platform_event_api_server_url === undefined) {
      console.error('Platform event API server URL is not set!');
      return Promise.reject('Platform event API server URL is not set!');
    }

    const apiUrl =
      this.platform_event_api_server_url +
      '/api/8/platformEvent/markInstoreAcceptanceV2';

    console.log('platform_event_api_server_url', apiUrl);
    console.log('requestData:', requestData);

    return firstValueFrom(
      this.httpClient.post<string>(apiUrl, requestData, {
        ...requireAppCheck,
        withCredentials: true,
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${this.getCookie('ezt-api-token')}`, // Needed for EZ-Tux; Dealer/Platform Portals will overwrite this with Firebase auth token via interceptor
        },
      }),
    );
  }

  private getCookie(name: string): string {
    let ca: Array<string> = document.cookie.split(';');
    let caLen: number = ca.length;
    let cookieName = `${name}=`;
    let c: string;

    for (let i: number = 0; i < caLen; i += 1) {
      c = ca[i].replace(/^\s+/g, '');
      if (c.indexOf(cookieName) == 0) {
        return c.substring(cookieName.length, c.length);
      }
    }
    return '';
  }
}
